import React from 'react';
import { HighSchoolBioCardFragment } from '../../../generated/spin-graphql';
import { Biography } from '../../profiles/Biography';
import { gql } from '@urql/core';
import { HighSchoolProfileInfo } from './HighSchoolProfileInfo';

type Props = {
    highSchool: HighSchoolBioCardFragment;
};

gql`
    fragment HighSchoolBioCard on espin_high_school {
        bio
        contact_email
        contact_name
        name
        ...HighSchoolProfileInfo
    }
`;

export const HighSchoolBioCard: React.FC<Props> = ({ highSchool }) => {
    return (
        <>
            <div className="high-school-bio-container">
                <HighSchoolProfileInfo highSchool={highSchool} />

                {highSchool.bio && <Biography biography={highSchool.bio} />}
            </div>
        </>
    );
};
